import { useMemo } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'
import Button from '../Button'

import style from './BoatSpecifications.style'

const BoatSpecificationsStyled = styled.div(props => ({ ...style(props) }))

// @TODO: Maybe add some display controls if some data does not come in

const BoatSpecifications = ({
    t,
    condition,
    conditionCrm,
    year,
    type,
    brand,
    cabins,
    length,
    beam,
    draft,
    engines,
    power,
    speedRange,
    boatID
}) => {
    const trueCondition = useMemo(() => {
        if (conditionCrm) {
            if (conditionCrm === 'Stock') return 'new-stock'
        }
        return condition
    }, [condition, conditionCrm])

    return (
        <BoatSpecificationsStyled>
            <div className="SpecificationTitle">{t('specification')}</div>

            <ul className="SpecificationList">
                {condition && (
                    <li>
                        <span>{t('condition')}</span> {t(`controls:${trueCondition}`)}
                    </li>
                )}

                {year && year !== 'NO_DATA' && (
                    <li>
                        <span>{t('year')}</span> {year}
                    </li>
                )}
                {type && (
                    <li>
                        <span>{t('type')}</span> {type}
                    </li>
                )}
                {brand && (
                    <li>
                        <span>{t('brand')}</span> {brand}
                    </li>
                )}
                {cabins && (
                    <li>
                        <span>{t('cabins')}</span> {cabins}
                    </li>
                )}
                {length && (
                    <li>
                        <span>{t('length-overall')}</span> {length} m
                    </li>
                )}
                {beam && (
                    <li>
                        <span>{t('beam')}</span> {beam} m
                    </li>
                )}
                {draft && (
                    <li>
                        <span>{t('draft')}</span> {draft} m
                    </li>
                )}
                {engines && (
                    <li>
                        <span>{t('engines')}</span> {engines}
                    </li>
                )}
                {power && (
                    <li>
                        <span>{t('power')}</span> {power} hp
                    </li>
                )}
                {speedRange && (
                    <li>
                        <span>{t('speed-range')}</span> {speedRange}
                    </li>
                )}
            </ul>
            <Button
                variation="secondary rounded fullWidth"
                dataAttrs={{
                    'gtm-event': 'link',
                    'gtm-label': 'Enquire',
                    'gtm-action': 'Enquire',
                    'gtm-category': 'Enquire'
                }}
                link={`/inquiry?boatID=${boatID}&type=buy`}>
                {t('no-obligation-inquiry')}
            </Button>
        </BoatSpecificationsStyled>
    )
}

BoatSpecifications.propTypes = {
    t: PropTypes.func.isRequired,
    condition: PropTypes.string,
    conditionCrm: PropTypes.string,
    year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    type: PropTypes.string,
    brand: PropTypes.string,
    cabins: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    length: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    beam: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    draft: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    engines: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    power: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    speedRange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    boatID: PropTypes.string
}

BoatSpecifications.defaultProps = {
    condition: null,
    conditionCrm: null,
    year: null,
    type: null,
    brand: null,
    cabins: null,
    length: null,
    beam: null,
    draft: null,
    engines: null,
    power: null,
    speedRange: null,
    boatID: null
}

export default withTranslation('common', 'controls')(withTheme(BoatSpecifications))
